// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { WorkOrder } from '@evolvemep/api-ts';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { TaskAdder } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/TaskAdder';
import { TaskTypesProvider } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/useTaskTypes';
import { AddTaskPopover } from 'modules/Shop/WorkOrders/WorkOrderDetail/Tasks/AddTaskPopover';

type Props = {
  workOrder: WorkOrder;
  onTasksAdded: () => void;
  opened: boolean;
  onClose: () => void;
};

const AddTasksToItemsModalContents = ({ workOrder, onTasksAdded }: Props) => (
  <TaskTypesProvider>
    <TaskAdder
      rightSideComponent={(selectedTasks, selectedGroups, resetSelection) => (
        <AddTaskPopover
          taskTypes={selectedTasks}
          taskTypeGroups={selectedGroups}
          onTasksAdded={() => {
            onTasksAdded();
            resetSelection();
          }}
          workOrderId={workOrder.workOrderId}
        />
      )}
    />
  </TaskTypesProvider>
);

export const AddTasksToItemsModal = (props: Props) => {
  const { opened, onClose, workOrder } = props;
  return (
    <WrappedModal
      title={workOrder.name}
      subtitle="Add tasks to items"
      miniHeader={workOrder.identifier}
      opened={opened}
      onClose={onClose}
      hideModalButtons
      size="lg"
      tall
    >
      <AddTasksToItemsModalContents {...props} />
    </WrappedModal>
  );
};
